import { apolloCache } from '../src/createClient';
import type { BroadcastConfigurableInMemoryCache } from '../src/broadcastConfigurableInMemoryCache';

export { createClient, resetApolloStats } from '../src/createClient';
export type { BroadcastConfigurableInMemoryCache };

export function getApolloCache() {
	return apolloCache;
}
